import { InfoCard, rem } from '@innovyze/stylovyze';

import styled from 'styled-components';

export const CustomInfoCard = styled(InfoCard)`
	width: 100%;
	height: 100%;
	margin: auto;
`;

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-end;
`;

export const MapContainer = styled.div`
	height: ${rem(370)};
`;
